import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

export type EventStatusHistoryRow =
  Database["public"]["Tables"]["event_status_history"]["Row"];

export interface EventStatusHistoryEntry extends EventStatusHistoryRow {
  changed_by_name?: string | null;
}

export function useEventStatusHistory(eventId: string | null) {
  return useQuery({
    queryKey: ["event-status-history", eventId],
    queryFn: async () => {
      if (!eventId) return [];

      const { data, error } = await supabase
        .from("event_status_history")
        .select("*, changed_by_profile:profiles!event_status_history_changed_by_fkey(display_name)")
        .eq("event_id", eventId)
        .order("changed_at", { ascending: false });
      if (error) throw error;

      return (data ?? []).map(({ changed_by_profile, ...row }): EventStatusHistoryEntry => ({
        ...row,
        changed_by_name: changed_by_profile?.display_name ?? null,
      }));
    },
    enabled: !!eventId,
  });
}
